module.exports = __webpack_public_path__ + "img/games-18.024ade5e.webp";